import React from "react";

import {
  ChartDonutThreshold,
  ChartDonutUtilization,
  ChartThemeColor
} from "@patternfly/react-charts/victory";

import { VictoryLabel } from "victory";

import ExamInfo from "./ExamInfo";

const QualificationProgressChart = ({
  group,
  data
}) => {
  const isDark = document.documentElement.classList.contains(
    "pf-v6-theme-dark"
  );

  const textColor = isDark
    ? "#f5f5f5"
    : "#151515";

  const theme =
    data.completed_percentage_for_group_qualification >= 75
      ? ChartThemeColor.green
      : ChartThemeColor.blue;

  return (
    <div
      style={{
        height: "125px",
        width: "105px",
        float: "left",
        textAlign: "center"
      }}
    >
      <ChartDonutThreshold
        constrainToVisibleArea
        data={[
          {
            x: `Warning at ${data.threshold.warning}%`,
            y: data.threshold.warning
          },
          {
            x: `Danger at ${data.threshold.danger}%`,
            y: data.threshold.danger
          }
        ]}
        invert
        labels={({ datum }) => datum.x || null}
        padding={{
          bottom: 5,
          left: 5,
          right: 5,
          top: 0
        }}
        width={145}
        height={125}
        subTitlePosition="bottom"
      >
        <ChartDonutUtilization
          themeColor={theme}
          data={{
            x: `Grupa ${group.group_symbol}: Realizacja arkuszy ${data.qualification_symbol}`,
            y: data.completed_percentage_for_group_qualification
          }}
          labels={({ datum }) =>
            datum.x
              ? `${datum.x}: ${datum.y}%`
              : null
          }
          subTitle={
            `${data.completed_for_group_qualification}/${data.number_of_sheets}`
          }
          title={
            `${data.completed_percentage_for_group_qualification}%`
          }
          animate
          thresholds={[
            { value: data.threshold.warning },
            { value: data.threshold.danger }
          ]}
          titleComponent={
            <VictoryLabel
              style={[
                {
                  fill: textColor,
                  fontSize: 18
                },
                {
                  fill: textColor,
                  fontSize: 12
                }
              ]}
            />
          }
        />
      </ChartDonutThreshold>

      <div
        title="Symbol kwalifikacji"
        style={{
          fontSize: "small",
          textAlign: "center"
        }}
      >
        <span>
          {data.qualification_symbol}
        </span>

        <br />

        <span
          title="Zrealizowanych arkuszy"
          style={{ fontSize: "x-small" }}
        >
          {data.completed_for_group_qualification}/
          {data.number_of_sheets}
        </span>

        <ExamInfo data={data} />
      </div>
    </div>
  );
};

export default QualificationProgressChart;